export default __webpack_public_path__ + "604adf2932b4c681a98853d5f968eef4.svg";